/* 🤖 this file was generated by svg-to-ts*/
export const icoFacebook: {
  name: 'facebook';
  data: string;
} = {
  name: 'facebook',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.614 21h-8.62A.993.993 0 013 20.006V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.993.993 0 01-.993.993H15.42v-6.97h2.34l.35-2.717h-2.69V9.578c0-.786.218-1.322 1.346-1.322h1.439v-2.43a19.23 19.23 0 00-2.097-.107c-2.074 0-3.494 1.266-3.494 3.59v2.004H10.27v2.716h2.345V21z" fill="#909090"/></svg>`
};
